<template>
  <div class="video-wrap" v-if="moduleData.video">
   <div
      class="usp-app-video-player-item-video-mask hide"
      @click="playVideo('base-video')"
    >
      <div class="play-btn"></div>
    </div>
    <video
      id="base-video"
      preload="auto"
      autoplay
      :src="moduleData.video"
      webkit-playsinline
      playsinline
      class="n_none"
      loop="loop"
      muted
      poster="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20220825165627167-iphone.png"
    >
      <source :src="moduleData.video" type="video/mp4" />
    </video>
  </div>
</template>
<script>
export default {
  name: "videoScreen",
  props: {
    moduleData: {
      type: Object,
    },
  },
  methods:{
    playVideo(el) {
      let baseVideo = document.getElementById(el);
      if (baseVideo) {
        baseVideo.paused ? baseVideo.play() : baseVideo.pause();
      }
    },
  }
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
  .video-wrap{
    position: relative;
    .usp-app-video-player-item-video-mask {
      opacity: 1;
      &.hide {
        opacity: 0;
      }
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: transparent;
      transition: background-color 0.5s $easeOutCubic,
        opacity 0.5s $easeOutCubic;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      .play-btn {
        width: 50px;
        height: 50px;
        background: setBgImg(
          "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628182137368-web_usp_vdo@2x.png",
          contain
        );
      }
    }
  }
 
#base-video {
  width: 100%;
  display: block;
}
</style>
